'use client'

import { Icon } from '@/components/Icon'

import styles from './MenuHeaderDefault.module.scss'
import { useContext, useState } from 'react'
import { AccountContext } from '@/context/AccountContextDpv'
import AccountPopupDpv from '@/components/Account/AccountPopupDpv/AccountPopupDpv'
import LoginPopupDpv from '@/components/Account/LoginPopupDpv/LoginPopupDpv'

const AccountBtn = ({ webview }: { webview: boolean }) => {
  const [open, setOpen] = useState<boolean>(false)
  const accountContext = useContext(AccountContext)

  if (webview) {
    return null
  }

  return (
    <>
      <button aria-label="Account" onClick={() => setOpen(true)} className={styles['account-btn']}>
        <Icon name="user" size={28} />
      </button>
      {accountContext?.loggedIn ? (
        <AccountPopupDpv isOpen={open} setIsOpen={setOpen} />
      ) : (
        <LoginPopupDpv isOpen={open} setIsOpen={setOpen} />
      )}
    </>
  )
}

export default AccountBtn
